module.exports = __webpack_public_path__ + "img/map_filter_assets.a822fd95.svg";